/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_Not_SureInputs */

const en_wc_dl_not_sure = /** @type {(inputs: Wc_Dl_Not_SureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not sure which file? Use WordCraft online instead, nothing to install.`)
};

/**
* | output |
* | --- |
* | "Not sure which file? Use WordCraft online instead, nothing to install." |
*
* @param {Wc_Dl_Not_SureInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_not_sure = /** @type {((inputs?: Wc_Dl_Not_SureInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_Not_SureInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_not_sure(inputs)
});
export { wc_dl_not_sure as "wc.dl.not_sure" }